export * from './okscreen.interface';
